import { inject, Injectable } from '@angular/core';
import { WorkitemOfferedNotifierService } from './workitem-offered-notifier.service';

@Injectable({
    providedIn: 'root',
})
class DesktopNotifierService {
    readonly #workitemOfferedNotifierService = inject(
        WorkitemOfferedNotifierService,
    );

    init() {
        void this.#workitemOfferedNotifierService;
    }
}

export const desktopNotifierInitialiser = () => {
    const desktopNotifierService = inject(DesktopNotifierService);
    desktopNotifierService.init();
};
